module.exports = __webpack_public_path__ + "static/img/video-cover-2.8ad4ac96.png";